// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.simx-check-select-list {
  height: 100%;
  position: relative;
}
.simx-check-select-list.simx-has-footer {
  padding-bottom: 38px;
}

.simx-check-select-list--layout-container {
  background-color: rgb(255, 255, 255);
  display: flex;
  flex-direction: column;
  height: 100%;
}

.simx-check-select-list--list-block {
  flex-grow: 1;
  max-height: 100%;
  overflow-y: auto;
  position: relative;
}

.simx-check-select-list--list-loading-indicator-block {
  position: absolute;
  top: 15%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.simx-check-select-list--list-container {
  height: 100%;
}

.simx-check-select-list--list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.simx-check-select-list--list-item {
  border-bottom: solid 1px rgb(230, 235, 235);
  display: flex;
  margin: 0;
  padding: 0;
}

.simx-check-select-list--list-item--check-block {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-grow: 0;
  flex-shrink: 0;
  padding: 8px 16px;
}
.simx-check-select-list--list-item.simx-disabled .simx-check-select-list--list-item--check-block {
  cursor: not-allowed;
}

.simx-check-select-list--list-item--check {
  background-color: rgb(255, 255, 255);
  border: solid 1px rgb(255, 255, 255);
  border-radius: 100%;
  box-shadow: 0 0 0 1px rgb(194.5833333333, 206.6666666667, 206.6666666667);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2px;
  transition: background-color 0.2s;
  width: 16px;
  height: 16px;
}
.simx-check-select-list--list-item.simx-checked .simx-check-select-list--list-item--check {
  background-color: rgb(123.75, 150, 150);
}
.simx-check-select-list--list-item.simx-disabled .simx-check-select-list--list-item--check {
  background-color: rgb(194.5833333333, 206.6666666667, 206.6666666667);
}
.simx-check-select-list--list-item--check .simx-icon {
  transition: opacity 0.2s;
}
.simx-check-select-list--list-item--check .simx-icon-path {
  fill: rgb(255, 255, 255);
}
.simx-check-select-list--list-item:not(.simx-checked) .simx-check-select-list--list-item--check .simx-icon {
  opacity: 0;
}

.simx-check-select-list--list-item--label-block {
  cursor: pointer;
  flex-grow: 1;
  padding: 8px 8px 8px 0;
}

.simx-check-select-list--list-item--label {
  display: block;
  font-size: 0.875rem;
  -webkit-user-select: none;
          user-select: none;
}
.simx-check-select-list--list-item.simx-disabled .simx-check-select-list--list-item--label {
  color: rgb(166, 167, 169);
}

.simx-check-select-list--header {
  background-color: rgb(230, 235, 235);
  border-bottom: solid 1px rgb(194.5833333333, 206.6666666667, 206.6666666667);
  flex-grow: 0;
  flex-shrink: 0;
}

.simx-check-select-list--footer {
  background-color: rgb(230, 235, 235);
  border-top: solid 1px rgb(194.5833333333, 206.6666666667, 206.6666666667);
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-family: "Quicksand";
  font-size: 0.875rem;
  height: 38px;
  padding: 0 12px;
  position: absolute;
  bottom: 0;
  width: 100%;
}

.simx-check-select-list--footer-block {
  font-family: "Quicksand";
  font-size: 0.875rem;
  font-weight: 400;
}
.simx-check-select-list--footer-block button {
  appearance: none;
  background: none;
  border: none;
  border-radius: 4px;
  box-shadow: inset 0 0 0 1px rgb(194.5833333333, 206.6666666667, 206.6666666667);
  color: inherit;
  cursor: pointer;
  font-family: inherit;
  font-size: inherit;
  font-weight: inherit;
  margin: 0;
  padding: 4px 8px;
  transition: background 0.2s, box-shadow 0.2s, color 0.2s, opacity 0.2s;
}
.simx-check-select-list--footer-block button:focus {
  outline: none;
}
.simx-check-select-list--footer-block button:hover, .simx-check-select-list--footer-block button:focus {
  background: rgb(123.75, 150, 150);
  box-shadow: inset 0 0 0 1px rgb(123.75, 150, 150);
  color: rgb(255, 255, 255);
}
.simx-check-select-list--footer-block button:active {
  background: rgb(99, 123.75, 123.75);
  box-shadow: inset 0 0 0 1px rgb(99, 123.75, 123.75);
  color: rgb(255, 255, 255);
}`, "",{"version":3,"sources":["webpack://./src/app/modules/ui-elements/components/controls/check-select-list/check-select-list.component.scss","webpack://./src/assets/styles/_colors.scss","webpack://./src/assets/styles/_fonts.scss","webpack://./src/assets/styles/_theme.scss"],"names":[],"mappings":"AAOA;EACE,YAAA;EACA,kBAAA;AANF;AAQE;EACE,oBAPY;AAChB;;AAUA;EACE,oCCD8B;EDE9B,aAAA;EACE,sBAAA;EACF,YAAA;AAPF;;AAUA;EACE,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;AAPF;;AAUA;EACE,kBAAA;EACE,QAAA;EACA,SAAA;EACF,gCAAA;AAPF;;AAUA;EACE,YAAA;AAPF;;AAUA;EACE,gBAAA;EACA,SAAA;EACA,UAAA;AAPF;;AAUA;EACE,2CAAA;EACA,aAAA;EACA,SAAA;EACA,UAAA;AAPF;;AAUA;EACE,eAAA;EACA,aAAA;EACE,mBAAA;EACA,uBAAA;EACF,YAAA;EACA,cAAA;EACA,iBAAA;AAPF;AASE;EACE,mBAAA;AAPJ;;AAWA;EACE,oCCrD8B;EDsD9B,oCAAA;EACA,mBAAA;EACA,yEAAA;EACA,aAAA;EACE,mBAAA;EACA,uBAAA;EACF,YAAA;EACA,iCAAA;EACA,WAAA;EACA,YAAA;AARF;AAUE;EACE,uCCnE4B;AD2DhC;AAWE;EACE,qECzE4B;ADgEhC;AAYE;EACE,wBAAA;AAVJ;AAaE;EACE,wBC9E4B;ADmEhC;AAeI;EACE,UAAA;AAbN;;AAkBA;EACE,eAAA;EACA,YAAA;EACA,sBAAA;AAfF;;AAkBA;EACE,cAAA;EACA,mBAAA;EACA,yBAAA;UAAA,iBAAA;AAfF;AAiBE;EACE,yBCjG4B;ADkFhC;;AAmBA;EACE,oCC9G8B;ED+G9B,4EAAA;EACA,YAAA;EACA,cAAA;AAhBF;;AAmBA;EACE,oCCrH8B;EDsH9B,yEAAA;EACA,aAAA;EACE,mBAAA;EACA,8BAAA;EACF,wBEpIgB;EFqIhB,mBAAA;EACA,YAlIc;EAmId,eAAA;EACA,kBAAA;EACE,SAAA;EACA,WAAA;AAhBJ;;AAmBA;EACE,wBE9IgB;EF+IhB,mBAAA;EACA,gBAAA;AAhBF;AAkBE;EACE,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,kBGvJ0B;EHwJ1B,+EAAA;EACA,cAAA;EACA,eAAA;EACA,oBAAA;EACA,kBAAA;EACA,oBAAA;EACA,SAAA;EACA,gBAAA;EACA,sEAAA;AAhBJ;AAqBI;EACE,aAAA;AAnBN;AAsBI;EAEE,iCC5J0B;ED6J1B,iDAAA;EACA,yBC7J0B;ADwIhC;AAwBI;EACE,mCAAA;EACA,mDAAA;EACA,yBCnK0B;AD6IhC","sourcesContent":["@use 'sass:color';\n@use 'colors';\n@use 'fonts';\n@use 'theme';\n\n$footer-height: 38px;\n\n.simx-check-select-list {\n  height: 100%;\n  position: relative;\n\n  &.simx-has-footer {\n    padding-bottom: $footer-height;\n  }\n}\n\n.simx-check-select-list--layout-container {\n  background-color: colors.$simxColorControlBackground;\n  display: flex;\n    flex-direction: column;\n  height: 100%;\n}\n\n.simx-check-select-list--list-block {\n  flex-grow: 1;\n  max-height: 100%;\n  overflow-y: auto;\n  position: relative;\n}\n\n.simx-check-select-list--list-loading-indicator-block {\n  position: absolute;\n    top: 15%;\n    left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.simx-check-select-list--list-container {\n  height: 100%;\n}\n\n.simx-check-select-list--list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.simx-check-select-list--list-item {\n  border-bottom: solid 1px colors.$simxColorLightNeutral;\n  display: flex;\n  margin: 0;\n  padding: 0;\n}\n\n.simx-check-select-list--list-item--check-block {\n  cursor: pointer;\n  display: flex;\n    align-items: center;\n    justify-content: center;\n  flex-grow: 0;\n  flex-shrink: 0;\n  padding: 8px 16px;\n\n  .simx-check-select-list--list-item.simx-disabled & {\n    cursor: not-allowed;\n  }\n}\n\n.simx-check-select-list--list-item--check {\n  background-color: colors.$simxColorWhite;\n  border: solid 1px colors.$simxColorWhite;\n  border-radius: 100%;\n  box-shadow: 0 0 0 1px colors.$simxColorControlBorder;\n  display: flex;\n    align-items: center;\n    justify-content: center;\n  padding: 2px;\n  transition: background-color theme.$simxTransitionSpeedDefault;\n  width: 16px;\n  height: 16px;\n\n  .simx-check-select-list--list-item.simx-checked & {\n    background-color: colors.$simxColorLightNeutralDarkest;\n  }\n\n  .simx-check-select-list--list-item.simx-disabled & {\n    background-color: colors.$simxColorControlBorder;\n  }\n\n  .simx-icon {\n    transition: opacity theme.$simxTransitionSpeedDefault;\n  }\n\n  .simx-icon-path {\n    fill: colors.$simxColorWhite;\n  }\n\n  .simx-check-select-list--list-item:not(.simx-checked) & {\n    .simx-icon {\n      opacity: 0;\n    }\n  }\n}\n\n.simx-check-select-list--list-item--label-block {\n  cursor: pointer;\n  flex-grow: 1;\n  padding: 8px 8px 8px 0;\n}\n\n.simx-check-select-list--list-item--label {\n  display: block;\n  font-size: 0.875rem;\n  user-select: none;\n\n  .simx-check-select-list--list-item.simx-disabled & {\n    color: colors.$simxColorTextLight;\n  }\n}\n\n.simx-check-select-list--header {\n  background-color: colors.$simxColorLightNeutral;\n  border-bottom: solid 1px colors.$simxColorControlBorder;\n  flex-grow: 0;\n  flex-shrink: 0;\n}\n\n.simx-check-select-list--footer {\n  background-color: colors.$simxColorLightNeutral;\n  border-top: solid 1px colors.$simxColorControlBorder;\n  display: flex;\n    align-items: center;\n    justify-content: space-between;\n  font-family: fonts.$simxFontGraphic;\n  font-size: 0.875rem;\n  height: $footer-height;\n  padding: 0 12px;\n  position: absolute;\n    bottom: 0;\n    width: 100%;\n}\n\n.simx-check-select-list--footer-block {\n  font-family: fonts.$simxFontGraphic;\n  font-size: 0.875rem;\n  font-weight: 400;\n\n  button {\n    appearance: none;\n    background: none;\n    border: none;\n    border-radius: theme.$simxBorderRadiusDefault;\n    box-shadow: inset 0 0 0 1px colors.$simxColorLightNeutralDark;\n    color: inherit;\n    cursor: pointer;\n    font-family: inherit;\n    font-size: inherit;\n    font-weight: inherit;\n    margin: 0;\n    padding: 4px 8px;\n    transition: background theme.$simxTransitionSpeedDefault,\n      box-shadow theme.$simxTransitionSpeedDefault,\n      color theme.$simxTransitionSpeedDefault,\n      opacity theme.$simxTransitionSpeedDefault;\n\n    &:focus {\n      outline: none;\n    }\n\n    &:hover,\n    &:focus {\n      background: colors.$simxColorLightNeutralDarkest;\n      box-shadow: inset 0 0 0 1px colors.$simxColorLightNeutralDarkest;\n      color: colors.$simxColorWhite;\n    }\n\n    &:active {\n      background: color.adjust(colors.$simxColorLightNeutralDarkest, $lightness: -10%);\n      box-shadow: inset 0 0 0 1px color.adjust(colors.$simxColorLightNeutralDarkest, $lightness: -10%);\n      color: colors.$simxColorWhite;\n    }\n  }\n}\n","@use 'sass:color';\n\n$simxColorBrightAccent:         rgb(229, 0, 44);  // Red\n$simxColorDarkAccent:           rgb(54, 47, 65);  // Purple\n$simxColorBrightGreen:          rgb(0, 201, 133);\n$simxColorMustard:              rgb(255, 177, 0);\n\n$simxColorDarkAccentMedium:     color.adjust($simxColorDarkAccent, $lightness: 6%);\n$simxColorDarkAccentLight:      color.adjust($simxColorDarkAccent, $lightness: 53%);\n$simxColorDarkNeutral:          rgb(21, 19, 25);\n$simxColorDarkNeutralLight:     color.adjust(color.adjust($simxColorDarkNeutral, $saturation: -7%), $lightness: 76%);\n$simxColorLightNeutral:         rgb(230, 235, 235);\n$simxColorLightNeutralLight:    color.adjust($simxColorLightNeutral, $lightness: 5%);\n$simxColorLightNeutralDark:     color.adjust($simxColorLightNeutral, $lightness: -12.5%);\n$simxColorLightNeutralDarker:   color.adjust($simxColorLightNeutral, $lightness: -25%);\n$simxColorLightNeutralDarkest:  color.adjust($simxColorLightNeutral, $lightness: -37.5%);\n$simxColorWhite:                rgb(255, 255, 255);\n\n$simxColorTextDefault:          $simxColorDarkNeutral;\n$simxColorTextLight:            rgb(166, 167, 169);\n$simxColorTextInvert:           rgba(255, 255, 255, 0.95);\n$simxColorTextOverDarkAccent:   rgba($simxColorWhite, 0.95);\n\n$simxColorControlBackground:    $simxColorWhite;\n$simxColorControlBorder:        $simxColorLightNeutralDark;\n","$simxFontDefault: 'Open Sans';\n$simxFontGraphic: 'Quicksand';\n","$simxBorderRadiusDefault:     4px;\n$simxBorderRadiusHeavy:       calc($simxBorderRadiusDefault * 2);\n\n$simxTransitionSpeedDefault:  0.2s;\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
